import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useGenerateContractContext } from '../context/GenerateContractProvider';

export const useCurrentReservation = () => {
    const { customerId, reservationId } = useGenerateContractContext();

    const { data: reservation } = useRepositorySuspenseQuery(
        'reservations',
        'getAll',
        {
            reservationIds: reservationId ? [reservationId] : undefined,
            accountIds: customerId ? [customerId] : undefined,
        },
        { select: (data) => (reservationId ? data?.reservations?.[0] : undefined) }
    );
    return reservation;
};
